import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar/dist/entry.nostyle';
import moment from 'moment';
import FaAngleUp from 'react-icons/lib/fa/angle-up';
import FaAngleDown from 'react-icons/lib/fa/angle-down';

import 'font-awesome/css/font-awesome.min.css';
import './styles.css';

class HistoryCalendar extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.props.onChange(value);
  }

  render() {
    const { history } = this.props;
    const dates = history.map(element => ({
      date: moment(element.createdAt),
      user: element.createdBy,
    }));
    return (
      <Calendar
        tileClassName={({ date }) => {
          const currentDates = dates.filter(elem => moment(elem.date).isSame(date, 'day'));
          if (currentDates.length > 0) {
            const includesOwnChange = currentDates.find(
              elem => elem.user.key === this.props.auth.uid,
            );
            if (includesOwnChange) {
              return 'selected-date-own';
            }
            return 'selected-date';
          }
          return null;
        }}
        prevLabel={<FaAngleUp style={{ cursor: 'pointer' }} size={36} />}
        nextLabel={<FaAngleDown style={{ cursor: 'pointer' }} size={36} />}
        onChange={this.onChange}
        value={this.props.value}
        locale={'en-EN'}
        minDetail="month"
        maxDetail="month"
      />
    );
  }
}

HistoryCalendar.defaultProps = {
  value: new Date(),
  history: [],
};
HistoryCalendar.propTypes = {
  onChange: PropTypes.func.isRequired,
  auth: PropTypes.shape({ uid: PropTypes.string.isRequired }).isRequired,
  value: PropTypes.instanceOf(Date),
  history: PropTypes.arrayOf(Object),
};
export default HistoryCalendar;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ChangeHistoryBox/HistoryCalendar/HistoryCalendar.js